/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FreelancerVerificationStatus = {
    Verified: 'VERIFIED',
    InProgress: 'IN_PROGRESS',
    NotVerified: 'NOT_VERIFIED',
    Expired: 'EXPIRED'
} as const;
export type FreelancerVerificationStatus = typeof FreelancerVerificationStatus[keyof typeof FreelancerVerificationStatus];


export function instanceOfFreelancerVerificationStatus(value: any): boolean {
    for (const key in FreelancerVerificationStatus) {
        if (Object.prototype.hasOwnProperty.call(FreelancerVerificationStatus, key)) {
            // @ts-ignore
            if (FreelancerVerificationStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FreelancerVerificationStatusFromJSON(json: any): FreelancerVerificationStatus {
    return FreelancerVerificationStatusFromJSONTyped(json, false);
}

export function FreelancerVerificationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerVerificationStatus {
    return json as FreelancerVerificationStatus;
}

export function FreelancerVerificationStatusToJSON(value?: FreelancerVerificationStatus | null): any {
    return value as any;
}

